<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Dashboard</div>

          <div class="card-body">
            Every respectful app must have a dashboard, right?!<br>
            <br>
            How else are you gonna get excited and nervous at the same time about all the numbers, great projects
            and occasional bills you forgot to pay before due? Don’t worry, I’ll remind you about those in advance, so
            make sure to check the dashboard regularly!<br>
            <br>
            These being said, let’s see what this wonder dashboard has to offer.<br>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>Unpaid expenses</h5>
                First, you’ll see the <b>“Unpaid expenses”</b> section, because
                they probably take priority in getting handled as soon as
                possible.<br>
                <br>
                Here are listed all the day-specific estimates from the
                current month, which don’t have any payments (partial or
                full) associated to them. In order to offer you the quickest
                bird’s eye view possible, all these expenses are grouped by
                date, having their parent ledger visible as well. This way,
                you know at a first glance what, when, and how much you
                need to write some checks for <i>pronto</i>.<br>
                <br>
                How to dismiss an unpaid expense from this list? Simple —
                pay it! :-) And then record the payment using the <i aria-hidden="true" class="pe pe-money"/> icon
                next to the expense title, either from this page, or from
                the <a href="/#/support/expenses">associated ledger page</a>.<br><br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/unpaid-expenses.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>Upcoming expense</h5>
                Now that the ’sensitive’ news is behind us, we can focus
                on the <b>“Upcoming expenses”</b>.<br>
                <br>
                This section is where you’ll have an overview with all the
                day-specific expenses that are due in the next 7 days.
                In terms of display format and available functions, this is
                very similar to the “Unpaid expenses” section: expenses
                grouped by date, parent ledger visible, and possibility to
                add a payment to an upcoming expense directly from this
                page.<br><br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/upcoming-expenses.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>The numbers</h5>
                And now, how about you lay back, grab some popcorn,
                and let the app do some math and give you... <b>“The
                numbers”</b>! Sweet!!<br>
                <br>
                For each ledger, you’ll get the following 5 very useful
                indicators:
                <ul>
                  <li><b>Spending</b> — this is the average amount of payments
                  within the last 12 months (or since you’ve started using
                  the app, in case that’s less than a year)</li>
                  <li><b>Unexpected</b> — or unplanned spendings. Any nonrecurring
                  payment that was estimated or directly added
                  during the current month qualifies as an unplanned
                  spending. Thus, this value is the average amount of
                  unplanned spendings within the last 12 months (or since
                  you’ve started using the app, in case that’s less than a
                  year)</li>
                  <li><b>Future spending</b> — in order to help you get a mediumterm
                  glimpse over the following year, the app assesses
                  your future spendings as the average amount of recorded
                  Estimates + Unexpected over the next 12 months</li>
                  <li><b>Minimal safety net</b> — because having some savings is
                  not only wise, but also offers you some peace of mind, you
                  get a recommendation of a minimal amount to set aside.
                  Financial advisors go for a minimum of 6-month spendings,
                  thus, the suggested minimal safety net will be 6 times the
                  Spending or Future Spending amount (depending on which
                  value is higher)</li>
                  <li><b>Optimal safety net</b> — once you acquire the minimal
                  safety net, you should definitely aim for the optimal one,
                  which is 12 times the Spending or Future Spending amount
                  (depending on which value is higher)</li>
                </ul>
                <br>
                Now that you savoured your popcorn and chewed on
                these numbers as well, it’s time to get to work and make
                those safety nets a reality! Good luck!<br><br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/the-numbers.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <br>
          </div>
          <div class="floating-bottom-container"><button onclick="window.history.back()" class="btn btn-primary floating-bottom-right">Go Back</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {}
  }
}
</script>
